<script>
    import { Button } from "svelte-chota";
    import { mdiChevronDown } from "@mdi/js";
    import { scrollto } from "svelte-scrollto";
</script>

<div class="parallax">
    <div class="content">
        <Button
            dropdown="menu"
            class="text-white"
            clear
            autoclose
            iconRight={mdiChevronDown}
        >
            <p><a href="#about" use:scrollto={"#about"}>about us</a></p>
            <p><a href="#team" use:scrollto={"#team"}>the team</a></p>
            <p><a href="#theory" use:scrollto={"#theory"}>our methods</a></p>
        </Button>
        <div class="logo">
            <img src="logo_white.png" alt="" />
        </div>
    </div>
</div>

<style>
    .parallax {
        height: 100vh;
        width: 100%;
        background-image: url("https://images.unsplash.com/photo-1483728642387-6c3bdd6c93e5?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1955&q=80");
        background-repeat: no-repeat;
        background-attachment: fixed;
        background-position: center;

        z-index: 1;
    }

    .content {
        height: 100vh;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .logo {
        height: fit-content;
        max-width: 700px;
    }
    .logo img {
        image-rendering: -webkit-optimize-contrast;
        width: 100%;
    }
    a {
        color: black;
    }
</style>
